import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {filter, find} from 'lodash';
import Card from 'src/components/Cards/Card';
import CollegeLogo from 'src/components/CollegeSearch/CollegeLogo';
import Icon from 'shared/components/icon';
import {groupCurrentAndCompleteScholarships} from 'shared/college-profile/utils';
import classnames from 'classnames';
import styles from './congrats.module.scss';
import usePlatformContext from '../../../../src/hooks/usePlatform';

const propTypes = {
  student: PropTypes.shape({
    firstName: PropTypes.string,
  }),
  college: PropTypes.shape({
    logo: PropTypes.string,
    redeemableTerm: PropTypes.string,
  }).isRequired,
  schoolId: PropTypes.string.isRequired,
  partnerScholarships: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      amount: PropTypes.number,
    })
  ),
  fetchPartnerScholarships: PropTypes.func.isRequired,
  claimAccountScholarshipText: PropTypes.string,
};

const firstNScholarships = (partnerScholarships, n = 2) => {
  const scholarships = filter(
    partnerScholarships,
    ({scholarshipType}) => scholarshipType === 'TimeSensitiveItemScholarship'
  ).slice(0, n);

  return scholarships.map(({title, amount}, i) => (
    <tr key={i} className={styles.tableRow}>
      <td className={classnames(styles.goal, styles.unchecked)}>{title}</td>
      <td className={styles.tableAmountContainer}>
        <span className={styles.tableAmount}>${amount}</span>
      </td>
    </tr>
  ));
};

const Congrats = (props) => {
  const {
    student: {firstName},
    college: {logo, redeemableTerm},
    schoolId,
    partnerScholarships,
    fetchPartnerScholarships,
  } = props;

  const {isIonic} = usePlatformContext();

  const claimedScholarship = find(
    partnerScholarships,
    ({scholarshipType}) => scholarshipType === 'ClaimedAccountScholarship'
  );
  const claimedAmount = (claimedScholarship && `$${claimedScholarship.amount}`) || '';
  const {currentScholarships} = groupCurrentAndCompleteScholarships(partnerScholarships);

  let subtitle = 'You have completed you account setup and are ready to start earning!';
  if (claimedScholarship) {
    subtitle = `You completed your first checklist item and earned ${claimedAmount} toward your ${redeemableTerm} Tuition!`;
  }

  useEffect(() => {
    if (!partnerScholarships && schoolId) {
      fetchPartnerScholarships(schoolId);
    }
  }, [partnerScholarships]);

  return (
    <>
      {!isIonic && <div className={styles.background}></div>}
      <div className={styles.container}>
        <div className={styles.cardContainer}>
          <h1 className={classnames(styles.header, {[styles.white]: !isIonic})}>
            Congrats{firstName ? `, ${firstName}` : ''}! 🎉
          </h1>
          <h2 className={classnames(styles.subHeader, {[styles.white]: !isIonic})}>{subtitle}</h2>
          <Card className={styles.card}>
            {logo && <CollegeLogo logo={logo} size={48} />}
            <p className={styles.amount}>{claimedAmount}</p>
            {claimedScholarship && (
              <p className={styles.text}>{redeemableTerm} Tuition Savings Earned</p>
            )}
            <hr />
            <table className={styles.table}>
              <caption className={styles.caption}>Your award checklist preview</caption>
              <tbody>
                {claimedScholarship && (
                  <tr className={styles.tableRow}>
                    <td className={styles.goal}>
                      <Icon iconType="check" className={styles.check} />
                      {props.claimAccountScholarshipText}
                    </td>
                    <td className={styles.tableAmountContainer}>
                      <span className={styles.tableAmount}>{claimedAmount}</span>
                    </td>
                  </tr>
                )}
                {partnerScholarships &&
                  firstNScholarships(currentScholarships, claimedScholarship ? 2 : 3)}
              </tbody>
            </table>
          </Card>
        </div>
      </div>
    </>
  );
};

Congrats.propTypes = propTypes;

export default Congrats;
